<template>
  <div class="time_line" :class="{bgPicter:!isNodata}">
    <v-chart :options="lineData" id="echart5" ref="timeLine" auto-resize @click="onEveryLine"></v-chart>
    <div class="no-chart-data" style="color:#D3D3D3;font-size:20px;" v-show="isNodata">Temporarily no data</div>
  </div>
</template>

<script>
let setOption = () => {
  let barColor = ["#FFAD5C", "#FF6666", "#0078FF"];
  let result = [];
  for (let i = 0; i < barColor.length; i++) {
    result.push({
      type: "bar",
      barWidth: "20%", //调整双柱状图之间的间隔的
      label: {
        normal: {
          show: true,
          color: "#4E5671",
          position: "right"
        }
      },
      itemStyle: {
        normal: {
          color: barColor[i]
        }
      }
    });
  }
  return result;
};

export default {
  name: "ETimeLine",
  //props: ["echartsData"],
  props: {
    echartsData: {},
    // 控制柱状图是否横向显示
    isHorizontal: {
      default: true
    },
    numShow: {
      type: Boolean,
      default: false
    },
    isNodata: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      lineData: {},
      xAxis: [],
      series: [],
      myChart5: ""
    };
  },
  mounted() {
    this.myChart5 = this.$refs.timeLine.chart;
    let myChart = this.myChart5;
    window.addEventListener("resize", () => {
      myChart.resize();
    });
    this.setOptions();
    //下钻
    myChart.getZr().on("dblclick", (params) => {
      var pointInPixel = [params.offsetX, params.offsetY];
      if (myChart.containPixel("grid", pointInPixel)) {
        /*此处添加具体执行代码*/
        var pointInGrid = myChart.convertFromPixel(
          { seriesIndex: 0 },
          pointInPixel
        );
        //X轴序号
        var xIndex = pointInGrid[0];
       
        //获取当前图表的option
        var op = myChart.getOption();
       
        //获得图表中我们想要的数据
        var month = op.xAxis[0].data[xIndex];
        if (month !== "") {
          this.$router.push({
            path: "/brand/BigFrame/logoDetail/Detail/LyricSearch",
            query: {
                id: sessionStorage.getItem("id"),
                time: month
            }
          });
        
        }
       
      }
    });
  },
  methods: {
    setOptions() {
      let echarts = require("echarts");
      let newResultData = this.$lodash.cloneDeep(this.echartsData);
      if (newResultData.length > 0) {
        newResultData[1].map((item, index) => {
          item = Object.assign(item, setOption()[index]);
          item.label.normal.show = this.numShow;
         
        });
        this.lineData = this.getOptions(newResultData, this.isHorizontal);
      }
      this.myChart5 = echarts.init(document.getElementById("echart5"));
      //this.myChart5 = echarts.init(this.$refs.timeLine);
    },
    getOptions(seriesData, Horizontal) {
      let xAxisVal = JSON.parse(JSON.stringify(seriesData[0]));
      let AseriesData = JSON.parse(JSON.stringify(seriesData[1]));
      return {
        toolbox: { //工具栏(下载)
          feature: {
            saveAsImage: {
              show: true,
              title: 'Save as picture'
            }
          },
          right: '5%'
        },
        grid: {
          top: "5%",
          left: "3%",
          containLabel: true
        },
        tooltip: {
          trigger: "axis",
          position: function(pt) {
            return [pt[0], "10%"];
          }
        },
        title: {
          show: false,
          text: "Emotion Trend"
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          axisLabel: {
            fontFamily: 'RCR'
          },
          data: (() => {
            return xAxisVal;
          })()
        },
        yAxis: {
          type: "value",
          boundaryGap: [0, "100%"],
          axisLabel: {
            fontFamily: 'RCR'
          }
        },
        dataZoom: [
          {
            type: "inside",
            start: 97,
            end: 100
          },
          {
            start: 0,
            end: 10,
            handleIcon:
              "M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z",
            handleSize: "80%",
            handleStyle: {
              color: "#fff",
              shadowBlur: 3,
              shadowColor: "rgba(0, 0, 0, 0.6)",
              shadowOffsetX: 2,
              shadowOffsetY: 2
            }
          }
        ],
        series: [
          {
            name: "emotional-data",
            type: "line",
            smooth: true,
            symbol: "none",
            sampling: "average",
            itemStyle: {
              color: "rgb(255, 70, 131)"
            },
            areaStyle: {
              color: new this.$Echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgb(255, 158, 68)"
                },
                {
                  offset: 1,
                  color: "rgb(255, 70, 131)"
                }
              ])
            },
            data: (() => {
              return AseriesData[0].data;
            })()
          }
        ]
      };
    },
    //点击折线图
    onEveryLine(params) {
      this.$emit("onEveryLine", params);
    }
  },
  watch: {
    isHorizontal(val) {},
    numShow(val) {},
    echartsData() {
      this.setOptions();
    }
  }
};
</script>

<style scoped>
.echarts {
  width: 100%;
  height: 100%;
}
.time_line {
  position: relative;
}
.time_line .no-chart-data {
  width: 300px;
  font-size: 25;
  font-weight: 600;
  position: absolute;
  left: 50%;
  right: 50%;
  transform: translate(-50%, -588%);
}
</style>
